import * as resultConsiderationTypes from './resultConsiderationTypes'
import useResultConsideration from './useResultConsideration'
import Autocomplete from '../../../../control/autocomplete/autocomplete'
import MyAccordion from '../../../../control/accordion/accordion'
import useTranslate from '../../../../i18n/useTranslate'
import React from 'react'
import { Grid, Typography } from '@material-ui/core'
import ModeAccordion from '../modeAccordion/ModeAccordion'
import MyCheckbox from '../../../../control/checkbox/checkbox'
import useAppFolderAndTabStore from '../../../../stores/appFolderAndTab/appFolderAndTabStore'
import submittedStep from '../../../../constants/submittedStep'

//View
const ResultConsiderationView = (props: resultConsiderationTypes.ResultConsiderationViewType) => {
    const { approveStatus, onChangeStatus, disabled = false, useAccordionMode, updateApproveStatus } = props
    const translate = useTranslate()
    const { tabSelected } = useAppFolderAndTabStore()

    const renderChild = (disabledVal: boolean) => {
        return (
            <Grid container item justify="flex-start" spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                    <Autocomplete
                        name="approveStatus"
                        materialInputProps={{
                            label: translate.get('LABEL.SELECT_ETHIC_REVIEW_OUTCOME'),
                            placeholder: translate.get('LABEL.PLEASE_SELECT'),
                            disabled: disabledVal,
                        }}
                        options={approveStatus}
                        onChangeValue={onChangeStatus}
                        required
                    />
                </Grid>
                {/* <Grid item xs={12} md={12} lg={12}>
                    <Grid container spacing={2}>
                        <Grid item>
                            <MyCheckbox name="consent" label="ยินยอมรักษาความลับ" required />
                        </Grid>
                    </Grid>
                </Grid> */}
                {tabSelected?.stepID === submittedStep.synthesis && (
                    <Grid item xs={12} md={12} lg={12}>
                        <Typography>{translate.get('LABEL.DURATION_PROGRESS_REPORT')}</Typography>
                        <Grid container spacing={2}>
                            <Grid item>
                                <MyCheckbox name="progress_6_months" label="6 Months" disabled={disabledVal} />
                            </Grid>
                            <Grid item>
                                <MyCheckbox name="progress_12_months" label="12 Months" disabled={disabledVal} />
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        )
    }

    return (
        <React.Fragment>
            {useAccordionMode ? (
                <ModeAccordion
                    renderEditComponent={() => renderChild(false)}
                    renderViewComponent={() => renderChild(true)}
                    title={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}
                    isViewMode={true}
                    fieldNames={['approveStatus']}
                    onConfirm={() => updateApproveStatus(['approveStatus'])}
                />
            ) : (
                <MyAccordion title={translate.get('LABEL.ETHIC_REVIEW_OUTCOME')}>{renderChild(disabled)}</MyAccordion>
            )}
        </React.Fragment>
    )
}

//Controller
const ResultConsideration = (props: resultConsiderationTypes.ResultConsiderationType) => {
    const { disabled } = props
    const resultConsiderationModel = useResultConsideration(props)
    return <ResultConsiderationView {...resultConsiderationModel} {...props} disabled={disabled} />
}

export default ResultConsideration
